import Utils from "../../services/Utils.js";
import { getCurrentBalance } from "../../js/api/balance.js";
import { getSports } from "../../js/api/sports.js";
import { _t } from "../../services/TranslationService.js";
import { filterBlockedSports } from "../../services/BlockedSports.js";

let Header = {
  render: async () => {
    let logedInBtn;
    let myBetsBtn;
    let profileBtn;
    let logedInState;
    let usersBtn;
    let createUsersBtn;
    let myProfileBtn;
    let access_token = localStorage.getItem("access_token");
    let match_sport = localStorage.getItem("matchSport");
    let profileName = localStorage.getItem("name");
    let username = localStorage.getItem("username");
    let profileSurname = localStorage.getItem("surname");
    let profileType = localStorage.getItem("role");
    let hierarchyOfUsers = [
      "User",
      "Agent",
      "Manager",
      "Supermanager",
      "Administrator",
      "Superadmin",
    ];

    if (access_token == "" || access_token == null) {
      logedInState = false;
      logedInBtn =
        `<div class="menuItem loginBtn registerBtn">${_t("Join")}</div>` +
        `<div class="menuItem loginBtn">${_t("Hyr")}</div>`;
      profileBtn = ``;
      myBetsBtn = "";
      usersBtn = "";
      createUsersBtn = "";
    } else {
      let user = Utils.parseJwt(access_token);

      if (
        profileType === "Manager" ||
        profileType === "Agent" ||
        profileType === "Supermanager" ||
        profileType === "Administrator" ||
        profileType === "Superadmin"
      ) {
        logedInBtn = "";
        usersBtn = `<a href="#/Users">${_t("Lista e Perdoruesve")}</a>`;
        createUsersBtn = `<a href="#/createnewuser">${_t("Krijo")} ${
          hierarchyOfUsers.indexOf(profileType) > -1
            ? hierarchyOfUsers[hierarchyOfUsers.indexOf(profileType) - 1]
            : _t("Perdorues")
        } </a>`;
        myProfileBtn = ""; //`<a href="#/userprofile/${user.data.id}">MyProfile</a>`;
        myBetsBtn = `<a id="myBetsPage" class="menuItem" href="#/mybetsusers${
          profileType === "Agent" ? "-agent" : ""
        }">${_t("My Bets")}</a>`;

        profileBtn = `
                    <div class="profileWrapper">
                        <a class="profileHandler">
                            <div class="profileMainDetails">
                                <span class="profileBalance">
                                    <i class="currentBalanceNew"></i>
                                </span>
                                <span class="profileName">${username}</span>
                            </div>
                            <div class="profileIcon">
                                <svg class="notHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g fill-rule="evenodd" transform="translate(1 1)" stroke="#26FFBE" fill="none"><path d="M3.903 26.472C6.33 22.46 10.839 20 16 20c5.16 0 9.67 2.459 12.097 6.472A15.963 15.963 0 0 1 16 32a15.963 15.963 0 0 1-12.097-5.528z"/><circle cx="16" cy="16" r="16"/><path d="M16 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/></g></svg>
                                <svg class="hovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g fill-rule="evenodd" transform="translate(1 1)" stroke="#FFF" fill="none"><path d="M3.903 26.472C6.33 22.46 10.839 20 16 20c5.16 0 9.67 2.459 12.097 6.472A15.963 15.963 0 0 1 16 32a15.963 15.963 0 0 1-12.097-5.528z"/><circle cx="16" cy="16" r="16"/><path d="M16 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/></g></svg>
                            </div>
                        </a>
                        <div class="profileDropdown">
                           <div class="arrow-up"></div>
                           <div class="profileDetail">
                                <a href="#/CurrentBalance" class="mainCredit">
                                    <span><i class="currentBalanceNew"></i></span>
                                </a>
                           </div>
                           <div class="profileNav">
                                ${myProfileBtn}
                                ${usersBtn}
                                ${createUsersBtn}
                                <a href="#/AccountBalance">${_t("Financa")}</a>
                                <a href="#/ChangePassword">${_t(
                                  "Ndrysho Fjalekalimin"
                                )}</a>
                                ${
                                  profileType === "Supermanager"
                                    ? `<a href="#/smfinances">${_t(
                                        "Raporti përqindjes"
                                      )}</a>`
                                    : ""
                                }
                                ${
                                  profileType === "Administrator"
                                    ? `<a href="#/jackpot">${_t("Jackpot")}</a>`
                                    : ""
                                }
                                <!-- <a href="http://${
                                  location.host
                                }/chat">Chat</a> -->
                                <a onclick="openChat()">${_t("Chat")}</a>
                                <a href="~/" id="logoutBtn">${_t("Largohu")}</a>
                            </div>
                        </div>
                    </div>
                `;
      }

      if (profileType === "User") {
        logedInBtn = "";
        myBetsBtn = `<a id="myBetsPage" class="menuItem" href="#/MyBets">My Bets</a>`;
        profileBtn = `<span class="currentBalanceNew font-bold text-[16px] leading-[40px] font-sans "></div>`;
      }

      logedInState = true;
    }

    let sportsView = "";
    let sports = [];
    sports = await getSports({ ttlMinutes: 10 });
    sports = filterBlockedSports(sports).filter(
      (sport) => sport && sport.id != 13 && sport.id != 15
    );

    const currentUrl = window.location.hash; // Get current hash URL
    let currentSportId = currentUrl.startsWith("#/sports/")
      ? currentUrl.split("/")[2]
      : null;

    // If the URL is the base path (without a sport ID), make the first sport active
    if (currentUrl === "" || currentUrl === "#/") {
      const defaultSport =
        sports.find((sport) => String(sport.id) === "1") || sports[0];
      currentSportId = defaultSport?.id?.toString() || null;
      if (currentSportId) {
        localStorage.setItem("matchSport", currentSportId);
      }
    }

    if (sports) {
      sports.forEach((sport) => {
        if (sport) {
          if (currentUrl.startsWith("#/match/")) {
            sportsView += `
                            <a href="#/sports/${sport.id}" sportid="${
              sport.id
            }" 
                                class="border-r flex flex-row flex-wrap text-white font-[400] text-[12px] leading-[25px] cursor-pointer h-[25px] font-sans space-x-1 px-2 items-center border-[#3d3d3d] 
                                ${
                                  sport.id.toString() === match_sport
                                    ? "bg-[#81011e]"
                                    : "hover:bg-[#8d741d]"
                                } betModuleSportBtn hd-${sport.name}">
                                <i class="h-[25px] w-[20px] bg-no-repeat bg-center bg-[length:20px] sport-${
                                  sport.name
                                }"></i>
                                <span class="w-full flex-1">${_t(
                                  sport.name
                                )} (${sport.count_sport})</span>
                            </a>
                        `;
          } else {
            const isActive =
              currentSportId && currentSportId == sport.id.toString();
            sportsView += `
                            <a href="#/sports/${sport.id}" sportid="${
              sport.id
            }" 
                                class="border-r flex flex-row flex-wrap text-white font-[400] text-[12px] leading-[25px] cursor-pointer h-[25px] font-sans space-x-1 px-2 items-center border-[#3d3d3d] 
                                ${
                                  isActive
                                    ? "bg-[#81011e]"
                                    : "hover:bg-[#8d741d]"
                                } betModuleSportBtn hd-${sport.name}">
                                <i class="h-[25px] w-[20px] bg-no-repeat bg-center bg-[length:20px] sport-${
                                  sport.name
                                }"></i>
                                <span class="w-full flex-1">${_t(
                                  sport.name
                                )} (${sport.count_sport})</span>
                            </a>
                        `;
          }
        }
      });
    }

    let view = `
            <section class="flex flex-wrap flex-row relative justify-between bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] w-full px-4 items-center content-center shadow-[3px_3px_3px_#000000] z-30" id="headerEvent">
                <div class="flex flex-wrap flex-row space-x-6">
                    <div class="flex">
                        <a class="text-white font-bold text-[15px] leading-[30px] font-sans min-w-[140px]" href="#/">
                            X
                        </a>
                    </div>
                    <a class="text-white font-bold text-[15px] leading-[30px] font-sans px-2 border-l bg-[rgb(141,116,29)]" href="#/">Baste</a>
                    <div class="flex flex-row flex-wrap items-center justify-center">
                        <a class="flex text-white font-[600] text-[14px] leading-[25px] h-[25px] font-sans px-2 border-l bg-black bg-opacity-20 hover:text-black hover:bg-[rgba(245,180,1,1)]" href="#/mybets">Biletat</a>
                        <a class="flex text-white font-[600] text-[14px] leading-[25px] h-[25px] font-sans px-2 border-l bg-black bg-opacity-20 hover:text-black hover:bg-[rgba(245,180,1,1)]" href="#/accountbalance">Financa</a>
                        <div class="flex relative subMenu">
                            <a class="flex text-white font-[600] text-[14px] leading-[25px] h-[25px] font-sans px-2 border-l bg-black bg-opacity-20 whitespace-nowrap hover:text-black hover:bg-[rgba(245,180,1,1)]">Info.</a>
                            <div class="absolute top-full left-0 w-[140px] bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-[3px_3px_3px_#000000] text-white h-0 overflow-hidden pointer-events-none transition-all ease-in-out duration-300 overflow-hidden">
                                <a class="flex text-white font-[400] border-b border-[black] text-[14px] leading-[25px] h-[25px] font-sans px-2 hover:text-black hover:bg-[rgba(245,180,1,1)]" href="#/terms">Rregullore</a>
                                <a class="flex text-white font-[400] text-[14px] leading-[25px] h-[25px] font-sans px-2 hover:text-black hover:bg-[rgba(245,180,1,1)]" href="#/changepassword">Fjalekalimi</a>
                            </div>
                        </div>

                        <a class="flex text-white font-[600] text-[14px] leading-[25px] h-[25px] font-sans px-2 border-l bg-black bg-opacity-20 hover:text-black hover:bg-[rgba(245,180,1,1)] border-r" href="#/" id="logoutBtn">Largohu</a>
                    </div>
                </div>
                <div class="flex flex-wrap flex-row text-white relative">
                    <!-- Credit Button -->
                    <div id="creditBtn" class="flex flex-wrap flex-row text-white space-x-2 hover:text-[#ffff00] cursor-pointer">
                        <span class="font-bold text-[16px] leading-[40px] font-sans">Krediti:</span>
                        ${profileBtn}
                    </div>

                    <!-- Credit Modal -->
                    <div id="creditModal" class="absolute top-[30px] right-[16px] w-[330px] text-[11px] leading-[20px] font-normal bg-black border-yellow-400 shadow-[3px_3px_3px_#000000] px-2 font-verdana h-0 overflow-hidden pointer-events-none transition-all ease-in-out duration-300 overflow-hidden">
                        <div class="w-full flex flex-wrap flex-row space-x-2">
                            <div class="grid grid-cols-4 text-yellow-400 w-full text-center">
                                <span></span>
                                <span>Lek</span>
                                <span>Euro</span>
                                <span>Dollare</span>
                            </div>
                            <div class="grid grid-cols-4 w-full text-white">
                                <span class="border-r border-[red] text-right px-1">Balanca</span>
                                <span class="balance-lek border-r border-[red] text-right px-1">0.00</span>
                                <span class="balance-euro border-r border-[red] text-right px-1">0.00</span>
                                <span class="balance-dollar text-right px-1">0.00</span>
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row items-end justify-end">
                            <div id="closeCredit" class="closeCredit w-[50px] text-center border border-white bg-[rgba(120,1,28,1)] overflow-hidden text-ellipsis cursor-pointer text-white mt-[10px]">Mbyll</div>
                        </div>
                    </div>
            </section>
            <div class="sportsList flex flex-wrap flex-row bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] w-full items-center content-center shadow-[3px_3px_3px_#000000] mt-2">
                <div class="w-full flex flex-row flex-wrap justify-between bg-black bg-opacity-60 h-[25px]">
                    <div class="flex flex-wrap flex-row flex-1 overflow-x-visible h-[25px] max-w-[calc(100%-42px)]">
                        <div class="slider w-full">
                            <a href="#/inplay" sportid="${0}" class="border-r flex flex-row flex-wrap text-white font-[400] text-[12px] leading-[25px] h-[25px] font-sans space-x-1 px-2 items-center border-[#3d3d3d] hover:bg-[#8d741d] betModuleSportBtn">
                                <i class="h-[25px] w-[20px] bg-no-repeat bg-center bg-[length:1000px] bg-[url('./img/topat2.png')] bg-no-repeat bg-left pt-[3px] "></i>
                                <span class="flex-1">Live</span>
                            </a>
                            ${sportsView}
                        </div>
                    </div>
                    <div class="flex flex-wrap flex-row space-x-1.5 py-1 h-[25px] px-2">
                        <div class="border-solid border-t-[10px] border-r-[10px] border-b-[10px] border-l-[0px] border-transparent border-r-white cursor-pointer"></div>
                        <div class="border-solid border-t-[10px] border-b-[10px] border-l-[10px] border-r-[0px] border-transparent border-l-white cursor-pointer"></div>
                    </div>
                </div>
            </div>
        `;

    return view;
  },
  after_render: async () => {
    const setupSubMenuHover = () => {
      const subMenu = document.querySelector(".subMenu");
      const subMenuDropdown = subMenu.querySelector("div");

      if (subMenu && subMenuDropdown) {
        subMenu.addEventListener("mouseenter", () => {
          subMenuDropdown.style.height = "50px"; // Adjust as needed
          subMenuDropdown.style.pointerEvents = "auto";
        });

        subMenu.addEventListener("mouseleave", () => {
          subMenuDropdown.style.height = "0";
          subMenuDropdown.style.pointerEvents = "none";
        });
      }
    };

    // Call this function inside `after_render`
    setupSubMenuHover();

    $(document).ready(function () {
      $("body .slider").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
      });
    });

    const creditBtn = document.getElementById("creditBtn");
    const creditModal = document.getElementById("creditModal");
    const closeCredit = document.getElementById("closeCredit");

    creditBtn.addEventListener("click", () => {
      if (creditModal.classList.contains("h-0")) {
        creditModal.classList.remove("h-0", "pointer-events-none");
        creditModal.classList.add("h-[94px]", "py-2", "border");
      } else {
        creditModal.classList.add("h-0", "pointer-events-none");
        creditModal.classList.remove("h-[94px]", "py-2", "border");
      }
    });

    closeCredit.addEventListener("click", () => {
      creditModal.classList.add("h-0", "pointer-events-none");
      creditModal.classList.remove("h-[94px]", "py-2", "border");
    });

    if (localStorage.getItem("access_token")) {
      const currentBalanceResult = await getCurrentBalance();
      const coins = [];

      // reset all three columns
      $(".balance-lek, .balance-euro, .balance-dollar").text("0.00");

      if (currentBalanceResult?.total_coins) {
        const setCell = (code, amount) => {
        const formattedAmount = parseFloat(amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        switch (code) {
          case "L":
            $(".balance-lek").text(formattedAmount);
            break;
          case "E":
          case "Euro":
            $(".balance-euro").text(formattedAmount);
            break;
          case "D":
          case "Dollar":
            $(".balance-dollar").text(formattedAmount);
            break;
          default:
            $(".balance-euro").text(formattedAmount);
        }
      };


        if (currentBalanceResult.total_coins.includes("|")) {
          currentBalanceResult.total_coins.split("|").forEach((raw) => {
            const [codePart, valuePart] = raw.split(";");
            const [id, code] = codePart.split(".");
            const amt = parseFloat(valuePart).toFixed(2);
            coins.push({ currency: code, id });
            setCell(code, amt);
          });
        } else {
          if (currentBalanceResult.currency) {
            const code = currentBalanceResult.currency;
            const amt = parseFloat(currentBalanceResult.total_coins).toFixed(2);
            coins.push({
              currency: code,
              id: currentBalanceResult.currency_id,
            });
            setCell(code, amt);
          } else {
            const [codePart, valuePart] =
              currentBalanceResult.total_coins.split(";");
            const [id, code] = codePart.split(".");
            const amt = parseFloat(valuePart).toFixed(2);
            coins.push({ currency: code, id });
            setCell(code, amt);
          }
        }

        localStorage.setItem("coins", JSON.stringify(coins));
      }
    }
  },
};

export default Header;
